import { Injectable } from '@angular/core';
import { ViewColumnState } from '../../../application-controller/store/states/view-col.states';
import { UserPermissionViewComponent } from '../permission-container/user-permission/user-permission-view/user-permission-view.component';
import { UserPermissionListingComponent } from '../permission-container/user-permission/user-permission-listing/user-permission-listing.component';
import { ViewColumn } from '../../../view-column';
import { UserPermissionRoleDetailsComponent } from '../permission-container/user-permission/user-permission-view/user-permission-role/user-permission-role-details/user-permission-role-details.component';
import { PermissionSetListingAddComponent } from '../permission-container/user-permission/user-permission-view/user-permission-role/user-permission-role-details/permission-set-listing/permission-set-listing-add/permission-set-listing-add.component';
import { PermissionSetListingConfigureLinesComponent } from '../permission-container/user-permission/user-permission-view/user-permission-role/user-permission-role-details/permission-set-listing/permission-set-listing-add/permission-set-listing-configure-lines/permission-set-listing-configure-lines.component';
import { PermissionSetListingConfigureLinesEditComponent } from '../permission-container/user-permission/user-permission-view/user-permission-role/user-permission-role-details/permission-set-listing/permission-set-listing-add/permission-set-listing-configure-lines/permission-set-listing-configure-lines-edit/permission-set-listing-configure-lines-edit.component';
import { PermissionSetListingConfigureLinesEditTargetComponent } from '../permission-container/user-permission/user-permission-view/user-permission-role/user-permission-role-details/permission-set-listing/permission-set-listing-add/permission-set-listing-configure-lines/permission-set-listing-configure-lines-edit/permission-set-listing-configure-lines-edit-target/permission-set-listing-configure-lines-edit-target.component';
import { PermissionSetListingDetailsComponent } from '../permission-container/user-permission/user-permission-view/user-permission-role/user-permission-role-details/permission-set-listing/permission-set-listing-detail/permission-set-listing-detail.component';
import { PermissionSetLineDetailsComponent } from '../permission-container/user-permission/user-permission-view/user-permission-role/user-permission-role-details/permission-set-listing/permission-set-listing-detail/permission-set-line/permission-set-line-details/permission-set-line-details.component';
import { UserPermissionSetAddComponent } from '../permission-container/user-permission/user-permission-view/user-permission-set/user-permission-set-add/user-permission-set-add.component';
import { UserPermissionSetDetailsComponent } from '../permission-container/user-permission/user-permission-view/user-permission-set/user-permission-set-details/user-permission-set-details.component';

@Injectable()

// This is where we need to change the view columns.
export class UserPermissionPagesService {

  private initialState: ViewColumnState = {
    firstColumn: new ViewColumn(0, UserPermissionListingComponent, 'User Permission Listing', {
      deactivateAdd: false,
      deactivateList: false,
    }),
    secondColumn: null,
    viewCol: [
      new ViewColumn(0, UserPermissionListingComponent, 'User Permission Listing', {
        deactivateAdd: false,
        deactivateList: false,
      }),
      new ViewColumn(1, UserPermissionViewComponent, 'View User Permissions', {
        deactivateReturn: false,
        deactivateList: false,
        selectedIndex: 0
      }),
      new ViewColumn(2, UserPermissionRoleDetailsComponent, 'View Role Details', {
        deactivateReturn: false,
        deactivateList: false,
        deactivateAdd: false,
        selectedIndex: 0
      }),
      new ViewColumn(3, PermissionSetListingAddComponent, 'Add Permission Set', {
        deactivateReturn: false,
        selectedIndex: 0
      }),
      new ViewColumn(4, PermissionSetListingConfigureLinesComponent, 'Configure Permission Set Lines', {
        deactivateAdd: false,
        deactivateList: false,
        deactivateReturn: false,
        selectedIndex: 0
      }),
      new ViewColumn(5, PermissionSetListingConfigureLinesEditComponent, 'Edit Permission Set Line Details', {
        deactivateReturn: false,
        selectedIndex: 0
      }),
      new ViewColumn(6, PermissionSetListingConfigureLinesEditTargetComponent, 'Add Target', {
        deactivateAdd: false,
        deactivateList: false,
        deactivateReturn: false,
        selectedIndex: 0
      }),
      new ViewColumn(7, PermissionSetListingDetailsComponent, 'View Permission Set Listing Details', {
        deactivateReturn: false,
        deactivateList: false,
        deactivateAdd: false,
        selectedIndex: 0
      }),
      new ViewColumn(8, PermissionSetLineDetailsComponent, 'View Permission Set Listing Details', {
        deactivateReturn: false,
        selectedIndex: 0
      }),
      new ViewColumn(9, UserPermissionSetAddComponent, 'Add Permission Set', {
        deactivateReturn: false,
        selectedIndex: 0
      }),
      new ViewColumn(10, UserPermissionSetDetailsComponent, 'View Permission Set Listing Details', {
        deactivateReturn: false,
        deactivateList: false,
        deactivateAdd: false,
        selectedIndex: 0
      }),
    ],
    breadCrumbs: [],
    leftDrawer: [],
    rightDrawer: [],
    singleColumn: false,
    prevIndex: null
  };

  get pages() {
    return this.initialState;
  }

  constructor() { }
}
